export default __webpack_public_path__ + "static/misc-ro-835222db277480869d6ccfa73ad72340.png";